import { config } from 'config';
import i18n from 'i18nextInstance';
import moment from 'moment';
import orderBy from 'lodash/orderBy';
import { theme } from 'styled';
import { uppercaseFirst } from 'shared/utils';
const {
    callTimerSeconds,
    doctorsRelated,
    identificationOptions,
    inCallHoursDisconnection
} = config;
const {
    dashboardCalling,
    dashboardError,
    dashboardPatient,
    dashboardWait
} = theme;

export const AUDIT_ACTIONS = orderBy([{
    label: i18n.t('Descarga de archivo del profesional'),
    value: 'DoctorDownloadFile'
}, {
    label: i18n.t('Turno autoasignado'),
    value: 'DoctorReassignAppointment'
}, {
    label: i18n.t('Asignación'),
    show: doctorsRelated,
    value: 'PatientAttach'
}, {
    label: i18n.t('Creación'),
    value: 'PatientCreate'
},  {
    label: i18n.t('Desasignación'),
    show: doctorsRelated,
    value: 'PatientDetach'
},  {
    label: i18n.t('Eliminación'),
    value: 'PatientDelete'
}, {
    label: i18n.t('Descarga de archivo del paciente'),
    value: 'PatientDownloadFile'
}, {
    label: i18n.t('Archivo enviado'),
    value: 'PatientExternalRecipeSent'
}, {
    label: i18n.t('Egreso'),
    value: 'PatientLogout'
}, {
    label: i18n.t('Ingreso'),
    value: 'PatientLogin'
}, {
    label: i18n.t('Edición'),
    value: 'PatientModify'
}].filter(({ show = true }) => show), ['label'], ['asc']);

export const RESTRICTED_KEYS = {
    absences: 'absences',
    appointmentTypes: 'appointmentTypes',
    appointments: 'appointments',
    campaigns: 'campaigns',
    configuration: 'configuration',
    coverages: 'coverages',
    dashboard: 'dashboard',
    manage: 'manage',
    offices: 'offices',
    professionals: 'professionals',
    specialties: 'specialties',
    statistics: 'statistics'
};

export const getActionLabel = search => {
    const action = AUDIT_ACTIONS.find(({ value }) => value === search);
    return !!action ? action.label : i18n.t('Desconocida');
};

export const agendaTypes = [{
    label: i18n.t('Todos'),
    value: ''
}, {
    label: i18n.t('Agendas'),
    value: 'agenda'
}, {
    label: i18n.t('Disponibles adicionales'),
    value: 'available'
}, {
    label: i18n.t('No disponibles'),
    value: 'unavailable'
}];

export const daysOfWeek = [{
    index: 1,
    label: i18n.t('Lunes')
}, {
    index: 2,
    label: i18n.t('Martes')
}, {
    index: 3,
    label: i18n.t('Miércoles')
}, {
    index: 4,
    label: i18n.t('Jueves')
}, {
    index: 5,
    label: i18n.t('Viernes')
}, {
    index: 6,
    label: i18n.t('Sábado')
}, {
    index: 7,
    label: i18n.t('Domingo')
}];

export const documentTypeOptions = identificationOptions.map((elem, index) => ({
    label: uppercaseFirst(elem),
    value: index + 1
}));

export const yesOrNoOptions = [{ label: i18n.t('Si'), value: true }, { label: i18n.t('No'), value: false }];

const CONNECTING = {
    color: dashboardCalling,
    hidePin: true,
    icon: 'settings_phone',
    statusLabel: i18n.t('Conectando')
};
const DERIVED = {
    color: dashboardWait,
    hidePin: true,
    icon: 'call_split',
    statusLabel: i18n.t('Derivada')
};

const DERIVING = {
    color: dashboardCalling,
    hidePin: true,
    icon: 'settings_phone',
    statusLabel: i18n.t('Derivando')
};

const DISCONNECTED = {
    color: dashboardError,
    disconnected: true,
    hidePin: true,
    icon: 'phone_disabled',
    statusLabel: i18n.t('Desconectada')
};

const DOCTOR_IN_ROOM = {
    color: dashboardCalling,
    icon: 'history',
    statusLabel: i18n.t('Profesional en sala'),
    waitingRoom: true
};

const ENDING = {
    color: dashboardWait,
    hidePin: true,
    icon: 'settings_phone',
    statusLabel: i18n.t('Finalizando llamada')
};

const EVOLVING = {
    color: dashboardWait,
    completing: true,
    hidePin: true,
    icon: 'settings_phone',
    recap: true,
    statusLabel: i18n.t('Completando evolución')
};

const EVOLUTION = {
    color: dashboardWait,
    hidePin: true,
    icon: 'assignment',
    recap: true,
    statusLabel: i18n.t('Evolución escrita')
};

const IN_CALL = {
    color: dashboardCalling,
    hidePin: true,
    icon: 'phone_in_talk',
    iconSize: 40,
    inCall: true,
    statusLabel: i18n.t('En llamada')
};

const NOT_ATTENDED = {
    color: dashboardError,
    icon: 'contactless',
    statusLabel: i18n.t('No disponible')
};

const NOT_AVAILABLE = {
    color: dashboardWait,
    statusLabel: i18n.t('No disponible')
};

const NOT_CONNECTED = {
    color: dashboardError,
    icon: 'phone_disabled',
    statusLabel: i18n.t('No conectada')
};

const NOT_RECEIVED = {
    color: dashboardError,
    icon: 'phone_disabled',
    statusLabel: i18n.t('No recibida')
};

const NOT_SUCCEDED = {
    color: dashboardError,
    icon: 'phone_disabled',
    notSucceded: true,
    statusLabel: i18n.t('No exitosa')
};

const OMMITED = {
    color: dashboardWait,
    hidePin: true,
    icon: 'highlight_off',
    omitted: true,
    recap: true,
    statusLabel: i18n.t('Evolución incompleta')
};

const OTHERACCEPTED = {
    color: dashboardWait,
    icon: 'phone_missed',
    statusLabel: i18n.t('Atendida por otro')
};

const REJECTED = {
    color: dashboardError,
    icon: 'highlight_off',
    rejected: true,
    statusLabel: i18n.t('Rechazada')
};

const RINGING = {
    color: dashboardCalling,
    icon: 'ring_volume',
    iconSize: 40,
    ringing: true,
    statusLabel: i18n.t('Sonando')
};

const ROOM_WAITING = {
    color: dashboardCalling,
    icon: 'history',
    statusLabel: i18n.t('Sala en espera')
};

const SUCCESSFUL = {
    color: dashboardPatient,
    hidePin: true,
    icon: 'check_circle_outline',
    recap: true,
    statusLabel: i18n.t('Exitosa'),
    successful: true
};

const TIMED_OUT = {
    color: dashboardError,
    icon: 'phone_missed',
    missed: true,
    notConnected: true,
    statusLabel: i18n.t('No atendida')
};

const WAITING_IN_ROOM = {
    color: dashboardCalling,
    icon: 'history',
    statusLabel: i18n.t('Esperando en sala'),
    waitingRoom: true
};

export const getStatus = (callStatus, doctorStatus, createdAt, disableParsing) => {
    switch (callStatus) {
    case 'Alert': return ((moment().diff(createdAt, 'seconds') > callTimerSeconds + 60) && !disableParsing)
        ? (doctorStatus === 'NotReceived' ? NOT_RECEIVED : NOT_CONNECTED)
        : RINGING;
    case 'Accepted': {
        switch (doctorStatus) {
        case 'Accepted': return moment().diff(createdAt, 'hours') >= inCallHoursDisconnection && !disableParsing ? DISCONNECTED : IN_CALL;
        case 'Connecting': return CONNECTING;
        case 'Derived': return DERIVED;
        case 'Deriving': return moment().diff(createdAt, 'seconds') > ((callTimerSeconds + 60) && !disableParsing) ? NOT_CONNECTED : DERIVING;
        case 'Disconnected': return DISCONNECTED;
        case 'Ending': return ENDING;
        case 'Evolving': return EVOLVING;
        case 'NotConnected': return NOT_CONNECTED;
        case 'NotReceived': return NOT_RECEIVED;
        case 'OtherAccepted': return OTHERACCEPTED;
        case 'Rejected': return REJECTED;
        case 'TimeOut': return TIMED_OUT;
        default: return NOT_AVAILABLE;
        }
    }
    case 'DoctorInRoom': return DOCTOR_IN_ROOM;
    case 'Evolution': return EVOLUTION;
    case 'Finalized':
        switch (doctorStatus) {
        case 'Accepted': return SUCCESSFUL;
        case 'Derived': return DERIVED;
        case 'Disconnected': return DISCONNECTED;
        case 'Ending': return ENDING;
        case 'EvolutionOmitted': return OMMITED;
        case 'Evolving': return EVOLVING;
        case 'NotConnected': return NOT_CONNECTED;
        case 'NotReceived': return NOT_RECEIVED;
        case 'NotSucceded': return NOT_SUCCEDED;
        case 'OtherAccepted': return OTHERACCEPTED;
        case 'Rejected': return REJECTED;
        case 'TimeOut': return TIMED_OUT;
        default: return NOT_AVAILABLE;
        }
    case 'Pending': return ((moment().diff(createdAt, 'seconds') > callTimerSeconds + 60) && !disableParsing)
        ? (doctorStatus === 'NotReceived' ? NOT_RECEIVED : doctorStatus === 'TimeOut' ? TIMED_OUT : NOT_CONNECTED)
        : (disableParsing && doctorStatus === 'NotReceived' ? NOT_RECEIVED : RINGING);
    case 'Room':
        switch (doctorStatus) {
        case 'OnHold': return ROOM_WAITING;
        case 'Pending': return ROOM_WAITING;
        default: return NOT_AVAILABLE;
        }
    case 'WaitingInRoom': return WAITING_IN_ROOM;
    default: return NOT_ATTENDED;
    }
};
